import {Component, OnInit, ViewChild} from '@angular/core';
import {Category} from "../../shared/models/category";
import {ItemsService} from "../../core/http/items.service";
import {MatDialog} from "@angular/material/dialog";
import {MatSnackBar} from "@angular/material/snack-bar";
import {
  CategoryDetailsPopupComponent
} from "../category-overview/category-details-popup/category-details-popup.component";
import {YesNoModalComponent} from "../../shared/components/yes-no-modal/yes-no-modal.component";
import {PrinterCategoryQueueAssignmentDto} from "../../shared/models/printer-category-queue-assignment-dto";
import {PrinterService} from "../../core/http/printer.service";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {Tenant} from "../../shared/models/tenant";
import {MatTableDataSource} from "@angular/material/table";
import {CancelledReceiptPosition} from "../../shared/models/cancelledReceiptPosition";
import {MatSort} from "@angular/material/sort";
import {PrinterDto} from "../../shared/models/printer-dto";

@Component({
  selector: 'app-queue-category-assignment',
  templateUrl: './queue-category-assignment.component.html',
  styleUrl: './queue-category-assignment.component.scss'
})
export class QueueCategoryAssignmentComponent implements OnInit {

  printQueueForm!: FormGroup;
  queueCategoryAssignments: PrinterCategoryQueueAssignmentDto[] = [];
  displayedColumns: string[] = ['guid', 'printCategory', 'queueName', 'tenantName', 'delete'];
  tenants: Tenant[] = [];

  currentSelectedTenant = '';

  dataSource!: MatTableDataSource<PrinterCategoryQueueAssignmentDto>;
  tenantFilterValues: string[] = [];
  @ViewChild(MatSort, {static: true}) sort!: MatSort;

  constructor(private printerService: PrinterService, private itemService: ItemsService,
              private dialog: MatDialog, private _snackBar: MatSnackBar, private fb: FormBuilder) {
    this.createForm();
  }

  populateTenantFilterValues() {
    const tenantsSet = new Set<string>();
    this.queueCategoryAssignments.forEach(categoryAssignment => {
      if (categoryAssignment.tenantName != null) {
        tenantsSet.add(categoryAssignment.tenantName);
      }
    });
    this.tenantFilterValues = Array.from(tenantsSet);
  }

  applyFilter(filterValue: string) {
    this.currentSelectedTenant = filterValue;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  ngOnInit(): void {
    this.loadData();
  }

  loadData(): void {
    this.printerService.getAllQueuePrintAssignments().subscribe({
      next: (response) => {
        this.queueCategoryAssignments = <PrinterCategoryQueueAssignmentDto[]> response;
        console.log(response);
        this.dataSource = new MatTableDataSource<PrinterCategoryQueueAssignmentDto>(this.queueCategoryAssignments);
        this.dataSource.filterPredicate = (data: PrinterCategoryQueueAssignmentDto, filter: string) => {
          return data.tenantName?.toLowerCase() === filter;
        };
        this.dataSource.sort = this.sort;
        this.populateTenantFilterValues();
        if (this.currentSelectedTenant !== '') {
          this.applyFilter(this.currentSelectedTenant);
        }
      },
      error: (error) => {
        console.log(error);
      }
    });

    this.printerService.getAllTenants().subscribe({
      next: (response) => {
        this.tenants = (<Tenant[]> response);
      },
      error: (error) => {
        console.log(error);
      }
    });
  }

  createForm() {
    this.printQueueForm = this.fb.group({
      printCategory: ['', Validators.required],
      queueName: ['', Validators.required],
      tenantId: ['', Validators.required],
    });
  }

  createPrinterQueueAssignment(): void {
    if (this.printQueueForm.invalid) {
      this._snackBar.open('Bitte alle Daten eingeben', 'Schließen', {duration: 3000});
      return;
    }
    this.printerService.createQueuePrintAssignment(this.printQueueForm.value).subscribe(response => {
      this.printQueueForm.reset();
      this._snackBar.open('Druckkategorie Zuordnung erstellt', 'Schließen', {duration: 3000});
      this.ngOnInit();
    });
  }

  deletePrintCategoryQueueAssignment(queuePrintCategoryAssignment: PrinterCategoryQueueAssignmentDto): void {
    this.dialog.open(YesNoModalComponent, {
      data: queuePrintCategoryAssignment.printCategory,
      width: '400px'
    }).afterClosed().subscribe(result => {
      if (result) {
        this.printerService.deleteQueuePrintAssignment(queuePrintCategoryAssignment.guid).subscribe(result => {
          this._snackBar.open('Queue ' + queuePrintCategoryAssignment.printCategory + ' gelöscht', 'Schließen', {duration: 3000});
          this.ngOnInit();
        });
      }
    });
  }


}
